import React, { useContext } from "react";
import { Typography, RadioGroup, Radio, FormControlLabel } from "@mui/material";
import { recruitmentRegistrationContext } from "../../RecruitmentRegistationPage";

export default function ProjectTypeField() {
  const { projectType, setProjectType } = useContext(
    recruitmentRegistrationContext
  );

  const handleChangeProjectType = (e) => {
    setProjectType(Number(e.target.value));
  };

  return (
    <RadioGroup row value={projectType || ""} onChange={handleChangeProjectType}>
      <FormControlLabel
        value={1}
        label={<Typography fontSize={16}>開発</Typography>}
        control={
          <Radio sx={{ "&.Mui-checked": { color: "#28345E" } }} />
        }
      />
      <FormControlLabel
        value={2}
        label={<Typography fontSize={16}>インフラ</Typography>}
        control={
          <Radio sx={{ "&.Mui-checked": { color: "#28345E" } }} />
        }
      />
      <FormControlLabel
        value={3}
        label={
          <Typography fontSize={16}>
            その他（コンサル、セキュリティ、デザイン、等その他）
          </Typography>
        }
        control={
          <Radio sx={{ "&.Mui-checked": { color: "#28345E" } }} />
        }
      />
    </RadioGroup>
  );
}